import $ from 'jquery';

const defaults = {
  sourceSelector: '.field-image',
};

function RandomImage(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.imageReady = this.imageReady.bind(this);
  this.addImage();
}

RandomImage.prototype = {
  getSource() {
    let source = '';
    const $sources = this.$element.find(this.settings.sourceSelector);
    if ($sources.length) {
      const winner = this.getRandomInt(0, $sources.length);
      source = $sources.eq(winner).find('img').attr('data-src');
    }
    return source;
  },
  addImage() {
    this.src = this.getSource();
    if (this.src && this.src.length) {
      const image = new Image();
      $(image).on('load', this.imageReady);
      image.src = this.src;
    } else {
      // Present the block, even if a image isn't found.
      this.ready();
    }
  },
  getRandomInt(_min, _max) {
    const min = Math.ceil(_min);
    const max = Math.floor(_max);
    return Math.floor(Math.random() * (max - min)) + min;
  },
  imageReady() {
    this.$element.find('.node-upper-image').css('background-image', `url(${this.src})`);
    this.ready();
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default RandomImage;



// WEBPACK FOOTER //
// ./RandomImage.js